import React, { useEffect } from "react";
import { AuthManager, readLogoutReason } from "./Auth";
import LoginLayout from "./LoginLayout";
import { Typography } from "@material-ui/core";

interface IProps {
  authProvider: AuthManager;
}

const LogOut = (props: IProps & any) => {
  useEffect(() => {
    props.authProvider.logoutFromIdentityProvider({
      reason: readLogoutReason(window.location.search),
    });
  }, [props.authProvider]);

  return (
    <LoginLayout>
      <Typography variant="body1">Logging out...</Typography>
    </LoginLayout>
  );
};

export default LogOut;
